var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, LocalForm, actions as formActions } from 'react-redux-form';
import { Icon } from "../UI";
import { t, Translate } from "../I18N";
import { reconnectSocket } from "../socket";
import RouteHandler from "../App/RouteHandler";
import { reloadThesauri } from "../Thesauri/actions/thesaurisActions";
import { withRouter } from "../componentWrappers";
import auth from "../Auth";

const reloadHome = () => {
  window.location.assign('/');
};

class LoginComponent extends RouteHandler {
  constructor(props, context) {
    super(props, context);
    this.state = {
      error: false,
      error2fa: false,
      recoverPassword: false,
      tokenRequired: false,
      render: false
    };
    this.submit = this.submit.bind(this);
    this.setLogin = this.setLogin.bind(this);
    this.setRecoverPassword = this.setRecoverPassword.bind(this);
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  submit(credentials) {
    if (this.state.recoverPassword) {
      return this.recoverPassword(credentials.username);
    }

    return this.login(credentials);
  }

  recoverPassword(email) {
    this.setState({ recoverPassword: false, error: false });
    this.formDispatch(formActions.reset('loginForm'));
    return this.props.recoverPassword(email);
  }

  resolveSuccessfulLogin() {
    if (this.props.private) {
      reloadHome();
      return;
    }
    reconnectSocket();
    this.props.reloadThesauris();
    this.props.change('library.search.publishedStatus.values', ['published', 'restricted']);
    reloadHome();
  }

  async login(credentials) {
    try {
      await this.props.login(credentials);
      this.resolveSuccessfulLogin();
    } catch (err) {
      if (!this.state.tokenRequired && err.status === 409) {
        this.setState({ tokenRequired: true });
      } else {
        const { tokenRequired } = this.state;
        this.formDispatch(formActions.change('loginForm.token', undefined));
        const error2fa = tokenRequired;
        this.setState({ error: true, tokenRequired, error2fa });
      }
    }
  }

  setRecoverPassword() {
    this.formDispatch(formActions.reset('loginForm'));
    this.setState({ recoverPassword: true, error: false });
  }

  setLogin() {
    this.formDispatch(formActions.reset('loginForm'));
    this.setState({ recoverPassword: false, tokenRequired: false, error: false, error2fa: false });
  }

  componentDidMount() {
    this.setState({ render: true });
  }

  render() {
    let submitLabel = this.state.recoverPassword ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Send recovery email") : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Login");


    if (this.state.tokenRequired) {
      submitLabel = /*#__PURE__*/_jsx(Translate, {}, void 0, "Verify");
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "content login-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "col-xs-12 col-sm-4 col-sm-offset-4" }, void 0, /*#__PURE__*/
      _jsx("h1", { className: "login-title" }, void 0, /*#__PURE__*/
      _jsx("img", { src: "/public/logo.svg", title: "uwazi", alt: "uwazi" })
      ),

      this.state.render && /*#__PURE__*/
      _jsx(LocalForm, {
        onSubmit: this.submit,
        model: "loginForm",
        getDispatch: (dispatch) => {
          this.formDispatch = dispatch;
        } }, void 0,

      !this.state.tokenRequired && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", {
        className: `form-group login-email${this.state.error ? ' has-error' : ''}` }, void 0, /*#__PURE__*/

      _jsx(Field, { model: ".username" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "username" }, void 0,
      this.state.recoverPassword ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Email") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "User")

      ), /*#__PURE__*/
      _jsx("input", { type: "text", name: "username", id: "username", className: "form-control" })
      )
      ), /*#__PURE__*/
      _jsx("div", {
        className: `form-group login-password ${this.state.error ? 'has-error' : ''}${
        this.state.recoverPassword ? ' is-hidden' : ''
        }` }, void 0, /*#__PURE__*/

      _jsx("label", { className: "form-group-label", htmlFor: "password" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Password")
      ), /*#__PURE__*/
      _jsx(Field, { model: ".password" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "password",
        name: "password",
        id: "password",
        className: "form-control" }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-text" }, void 0,
      this.state.error && /*#__PURE__*/_jsx("span", {}, void 0, t('System', 'Login failed'), " - "), /*#__PURE__*/
      _jsx("span", {
        title: t('System', 'Forgot Password?', null, false),
        onClick: this.setRecoverPassword,
        className: `button forgot-password ${
        this.state.error ? 'label-danger' : ''
        }` }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Forgot Password?")
      )
      )
      )
      ),

      this.state.tokenRequired && /*#__PURE__*/
      _jsx("div", {
        className: `form-group login-token${this.state.error2fa ? ' has-error' : ''}` }, void 0, /*#__PURE__*/

      _jsx("h5", {}, void 0, t('System', 'Two-step verification')), /*#__PURE__*/
      _jsx(Field, { model: ".token" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "token" }, void 0,
      t('System', 'Authentication code')
      ), /*#__PURE__*/
      _jsx("input", { type: "text", name: "token", id: "token", className: "form-control" }), /*#__PURE__*/
      _jsx("div", { className: "form-text" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0,
      this.state.error2fa && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), /*#__PURE__*/
      _jsx("span", {}, void 0, t('System', 'Two-factor verification failed'))
      )

      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Open the two-factor Authenticator app on your device"

      ), ' ', /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "to view your authentication code and verify your identity."

      )
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx("span", {
        onClick: this.setLogin,
        className: `button forgot-password ${
        this.state.error2fa ? 'label-danger' : ''
        }` }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Return to login")
      )
      )
      )
      )
      ), /*#__PURE__*/

      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "submit",
        className: `btn btn-block btn-lg ${
        this.state.recoverPassword ? 'btn-success' : 'btn-primary'
        }` }, void 0,

      submitLabel
      )
      ),
      this.state.recoverPassword && /*#__PURE__*/
      _jsx("div", { className: "form-text" }, void 0, /*#__PURE__*/
      _jsx("span", {
        title: t('System', 'Cancel', null, false),
        onClick: this.setLogin,
        className: "button cancel" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")
      )
      )

      )

      )
      )
      ));

  }
}

LoginComponent.propTypes = {
  login: PropTypes.func,
  recoverPassword: PropTypes.func,
  reloadThesauris: PropTypes.func,
  change: PropTypes.func
};

function mapStateToProps({ settings }) {
  return {
    private: settings.collection.get('private')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login: auth.actions.login,
      recoverPassword: auth.actions.recoverPassword,
      reloadThesauris: reloadThesauri,
      change: formActions.change
    },
    dispatch
  );
}

const Login = withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponent));

export { Login, LoginComponent, mapStateToProps };